<template>
  <div class="asset-lock">
    <div class="info">
      <div
        style="width: 100%"
        v-if="
          !lockCloseStart ||
          !lockCloseEnd ||
          now < lockCloseStart ||
          lockCloseEnd < now
        "
      >
        <div class="tips tips-red" v-if="lockCloseStart">
          {{
            $t("tips.mustLockBefore").replace(
              "{d}",
              lockCloseStart.toLocaleString()
            )
          }}
        </div>
        <div class="lock-form">
          <div class="lock-amount">
            <input
              class="lock-input"
              type="text"
              autocomplete="off"
              :value="amount"
              @input="onAmountInput"
              :placeholder="$t('asset.lockAmountPlaceholder')"
            />
          </div>
          <div class="lock-period">
            <!-- <Select
            class="select lock-input"
            :placeholder="$t('asset.selectPeriodPlaceholder')"
            @on-change="onPeriodChange"
            v-model="selectedPeriod"
          >
            <Option :value="item.id" v-for="item in periodList" v-bind:key="item.id">{{item.name}}</Option>
            </Select>-->
            <input
              class="lock-input"
              readonly
              type="text"
              autocomplete="off"
              :value="$t('asset.lockTime') + ':' + lockPeriodText"
            />
          </div>
          <div class="lock-btn">
            <dna-button v-if="!canLock" class="btn disabled">{{
              $t("asset.createLockCannot")
            }}</dna-button>
            <dna-button v-if="canLock" class="btn" @click="onConfirmClick">{{
              $t("asset.createLock")
            }}</dna-button>

            <div class="btn-fee">
              {{ $t("asset.lockFee") }}{{ formatToken(feeLock) }}
              {{ $t("asset.withdrawFee") }}{{ formatToken(feeWithdraw) }}
            </div>
          </div>
        </div>
      </div>
      <div
        style="width: 100%"
        v-if="
          lockCloseStart &&
          lockCloseEnd &&
          lockCloseStart < now &&
          now < lockCloseEnd
        "
      >
        <div class="tips tips-red" v-if="lockCloseStart">
          {{ $t("tips.canNotLock") }}
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <div class="history">
      <div class="table">
        <!-- 表头 -->
        <div class="head">
          <div>{{ $t("asset.lockType") }}</div>
          <div>{{ $t("asset.lockAmount") }}</div>
          <div>{{ $t("asset.lockTime") }}</div>
          <div>{{ $t("asset.unlockTime") }}</div>
          <div>{{ $t("asset.unlockAmount") }}</div>
          <div>{{ $t("asset.lockWithdraw") }}</div>
        </div>
        <!-- 表身 -->
        <div class="body" v-for="(item, index) in tableData" :key="index">
          <div>{{ $t("asset.lockType" + item.balance_type) }}</div>
          <div>{{ formatToken(item.amount) }}</div>
          <div>
            {{
              UTIL.formatTimeDistance(
                Math.abs(item.lockTime.getTime() - new Date().getTime()),
                item.lockTime > now
              )
            }}
          </div>
          <div>
            {{
              item.balance_type == "cashback" || item.balance_type == "witness"
                ? $t("asset.unlockTimeLinear")
                : UTIL.formatTimeDistance(
                    Math.abs(item.unlockTime.getTime() - new Date().getTime()),
                    item.unlockTime > now
                  )
            }}
          </div>
          <div>
            {{
              item.withdraw_available
                ? formatToken(item.withdraw_available)
                : "0"
            }}
          </div>
          <div
            v-if="
              (!item.withdraw_available || item.withdraw_available <= 0) &&
              item.requested_withdraw <= 0
            "
            class="withdraw"
          >
            <!-- 锁仓时间未 -->
            {{ $t("asset.locking") }}
          </div>
          <div v-if="item.requested_withdraw > 0" class="withdraw">
            <!-- 锁仓时间未 -->
            {{ $t("asset.withdrawInNextElection") }}
          </div>
          <div
            v-if="item.withdraw_available > 0 && item.requested_withdraw <= 0"
            class="withdraw"
          >
            <!-- 时间已过，未提现，可以提现 -->
            <a
              v-if="canWithdraw || item.balance_type != 'governance'"
              @click="() => onWithdrawClick(item)"
              >{{ $t("asset.unlock") }}</a
            >
            <span v-if="!canWithdraw && item.balance_type == 'governance'">{{
              $t("asset.unlockInA")
            }}</span>
          </div>
          <!-- <div v-if="item.status==2">
            {{$t("asset.unlocked")}}
          </div>-->
        </div>
      </div>
    </div>

    <dna-spin v-if="isLoading"></dna-spin>
    <!-- 输入密码 -->
    <dna-password-modal
      :isShow="isPasswordModalShow"
      @closed="isPasswordModalShow = false"
      @confirm="onPasswordConfirm"
    ></dna-password-modal>
  </div>
</template>

<script>
import wsSubscribe from "@/req/wsSubscribe.js";
import tx from "@/req/tx.js";
import req from "@/req/req.js";
import wallet from "@/util/wallet.js";
import UTIL from "@/util/util.js";
import ERROR from "@/util/error.js";
import DATA from "@/data/data.js";
import BigNumber from "bignumber.js";
export default {
  // 参数
  data() {
    let that = this;
    return {
      //temp
      //lockCloseStart: new Date("Thu Oct 08 2020 21:00:00 GMT+0800"),
      //lockCloseEnd: new Date("Thu Dec 08 2020 21:00:00 GMT+0800"),
      lockCloseStart: new Date("Thu Dec 03 2020 21:00:00 GMT+0800"),
      lockCloseEnd: new Date("Sun Dec 06 2020 21:00:00 GMT+0800"),
      isPasswordModalShow: false,
      isLoading: true,
      amount: "",
      currentRound: "",
      canLock: false,
      canWithdraw: false,
      lockPeriod: null,
      lockPeriodText: null,
      selectedPeriod: 0,
      periodList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((it) => {
        return {
          id: it,
          name: that.$t("asset.votePeriod" + it),
        };
      }),
      tableData: [],
      now: new Date(),
      passwordType: 0, //0 lock,1 withdraw
      withdrawItem: null,
      feeLock: 0,
      feeWithdraw: 0,
      UTIL,
      periodTime: null,
    };
  },
  async mounted() {
    let that = this;
    setInterval(() => {
      that.now = new Date();
    }, 1000);
    try {
      await that.load();
    } catch (err) {
      console.log(err);
      that.isLoading = false;
      let msg = that.$t("global.networkError");
      that.$Message.error({
        background: true,
        duration: 5,
        content: msg,
      });
    }
  },
  methods: {
    async load() {
      //获取可用余额
      let that = this;
      if (!that.address) {
        that.$router.push("/").catch((err) => {});
        return;
      }
      setInterval(() => {
        this.loadVestingBalances().catch();
        this.loadRound().catch();
        this.loadTime().catch();
      }, 30 * 1000);
      await this.loadVestingBalances();
      await this.loadRound();
      await this.loadFee();
      await this.loadTime();

      that.isLoading = false;
    },

    async loadFee() {
      let that = this;
      let feeResults = await wsSubscribe.wsFetchOperationFees([
        "vesting_balance_create",
        "vesting_balance_withdraw",
      ]);
      //console.log(feeResults)
      if (feeResults.length) {
        that.feeLock = feeResults[0].fee;
        that.feeWithdraw = feeResults[1].fee;
      }
    },
    async loadVestingBalances() {
      let that = this;
      let vestingBalances = await wsSubscribe.wsGetVestingBalances(
        that.address
      );
      //console.log("vestingBalances")
      //console.log(vestingBalances)
      if (!vestingBalances || !vestingBalances.length) {
        return;
      }
      vestingBalances = vestingBalances.filter(
        (it) => it.balance.asset_id == DATA.TOKEN_ASSET_ID
      );
      let results = [];
      let now = new Date();
      for (var i = 0; i < vestingBalances.length; i++) {
        let vb = vestingBalances[i];
        let obj = {
          id: vb.id,
          amount: vb.balance.amount,
          begin: null,
          end: null,
          seconds: 0,
          requested_withdraw: 0,
          balance_type: vb.balance_type,
        };
        if (vb.policy[0] == 3) {
          //cliff_vesting_policy_initializer
          obj.lockTime = new Date(vb.policy[1].begin_timestamp + "Z");
          obj.seconds = vb.policy[1].vesting_duration_seconds;
          obj.requested_withdraw = vb.policy[1].requested_withdraw || 0;
          obj.unlockTime = new Date(
            obj.lockTime.getTime() + obj.seconds * 1000
          );
          //obj.withdraw_available = obj.amount - obj.requested_withdraw;
          if (obj.unlockTime < now) {
            //现在已经超过解锁时间，全部解锁
            obj.withdraw_available = obj.amount - obj.requested_withdraw;
          }
        } else if (vb.policy[0] == 2) {
          //instant_vesting_policy_initializer
          //TODO:
          obj.lockTime = new Date();
          obj.unlockTime = new Date();
          obj.withdraw_available = 0;
        } else if (vb.policy[0] == 1) {
          //cdd_vesting_policy_initializer
          obj.lockTime = new Date(
            vb.policy[1].coin_seconds_earned_last_update + "Z"
          );
          obj.seconds = vb.policy[1].vesting_seconds;
          //开始解锁时间
          obj.unlockTime = new Date(vb.policy[1].start_claim + "Z");
          obj.withdraw_available = 0;
          if (obj.unlockTime < now) {
            //现在已经超过开始解锁时间
            let cs_earned = that.com_cs_eard(vb.policy[1], obj.amount);
            obj.withdraw_available = parseInt(
              cs_earned / Math.max(vb.policy[1].vesting_seconds, 1)
            );
            if (obj.withdraw_available > obj.amount) {
              obj.withdraw_available = obj.amount;
            }
          }
        } else if (vb.policy[0] == 0) {
          //linear_vesting_policy_initializer
          obj.lockTime = new Date(vb.policy[1].begin_timestamp + "Z");
          //vesting_cliff_seconds 超过可以提取
          //vesting_duration_seconds 可以全部提取
          obj.unlockTime = new Date(vb.policy[1].vesting_cliff_seconds + "Z");
          if (obj.unlockTime < now) {
            let endTime = new Date(vb.policy[1].vesting_duration_seconds + "Z");
            let amount = parseFloat(vb.policy[1].begin_balance.amount);
            if (endTime < now) {
              obj.withdraw_available = amount;
            } else {
              let passSeconds = parseInt(
                now.getTime() - obj.unlockTime.getTime() / 1000
              );
              let totalSecond =
                vb.policy[1].vesting_duration_seconds -
                vb.policy[1].vesting_cliff_seconds;
              obj.withdraw_available = amount * (passSeconds / totalSecond);
            }
          }
        } else {
        }
        console.log(obj);
        results.push(obj);
      }
      results = results.sort((a, b) => {
        return a.begin > b.begin ? -1 : 1;
      });
      //results = results.filter((it) => it.balance_type != "witness");
      that.tableData = results;
    },
    com_cs_eard(p, amt) {
      let delta_seconds = parseInt(
        (new Date().getTime() -
          new Date(p.coin_seconds_earned_last_update + "Z").getTime()) /
          1000
      );
      let delta_coin_seconds = new BigNumber(amt);
      delta_coin_seconds = delta_coin_seconds.times(delta_seconds);
      let coin_seconds_earned_cap = new BigNumber(amt);
      coin_seconds_earned_cap = coin_seconds_earned_cap.times(
        Math.max(p.vesting_seconds, 1)
      );

      let v1 = delta_coin_seconds.plus(p.coin_seconds_earned);
      let v2 = coin_seconds_earned_cap;
      if (v1.isGreaterThan(v2)) {
        return v2.toFixed(0);
      } else {
        return v1.toFixed(0);
      }
      //return Math.min(+delta_coin_seconds, coin_seconds_earned_cap);
    },
    async loadRound() {
      let that = this;
      let round = await wsSubscribe.wsFetchVotingPeriod();
      that.currentRound = round;
      if (round == "pre" || round == "b") {
        that.canLock = true;
      }
      if (round == "a") {
        that.canWithdraw = true;
      }
    },
    async loadTime() {
      let that = this;
      let properties = await wsSubscribe.wsFetchGlobalProperites();
      if (properties && properties.next_era_start_time) {
        let nextRoundTime = new Date(properties.next_era_start_time + "Z");

        that.era_round = properties.era_round;
        var newbasedateTime = UTIL.getnewdata(new Date(DATA.strbaseBlockChainStartTime),  (that.era_round - 1) *64);
        that.lockCloseStart = UTIL.getnewdata(newbasedateTime, 56);
        that.lockCloseEnd = UTIL.getnewdata(newbasedateTime, 60);

        let round1 = new Date("Thu Oct 08 2020 21:00:00 GMT+0800");
        // if (nextRoundTime < round1) {
        //   //TODO:temp fix bug of round 1, 2020-10-05;
        //   nextRoundTime = round1;
        // }
        that.periodTime = UTIL.culPeriod(nextRoundTime);
        let now = new Date();
        that.lockPeriod = that.periodTime.second;
        if (
          that.periodTime.current.start <= now &&
          now < that.periodTime.current.a
        ) {
          //pre轮，加上A轮的时间
          that.lockPeriod += parseInt(
            (that.periodTime.current.a.getTime() - now.getTime()) / 1000
          );
        } else {
          //减去和A轮的差
          that.lockPeriod -= parseInt(
            (now.getTime() - that.periodTime.current.a.getTime()) / 1000
          );
        }
        that.lockPeriodText = parseInt(that.lockPeriod / (24 * 60 * 60)) + "天";
        console.log("that.lockPeriod:" + that.lockPeriod);
      }
    },
    formatToken(val) {
      return UTIL.formatTokenWithOptions(val, {
        trimZero: true,
        numeralSymbols: [],
        tokenDecimal: 4,
      }); //
    },
    formatTokenWithoutSymbol(val) {
      return UTIL.formatTokenWithOptions(val, {
        trimZero: true,
        numeralSymbols: [],
        tokenDecimal: 4,
        tokenSymbol: "",
      }); //
      //return UTIL.formatToken(val, [], 4, ""); //
    },
    onWithdrawClick(item) {
      //console.log(JSON.stringify(item));
      let that = this;
      that.passwordType = 1;
      that.withdrawItem = item;
      that.isPasswordModalShow = true;
    },
    onAmountInput(e) {
      let value = e.target.value;
      value = value.replace(new RegExp(",", "g"), "");
      this.amount = value;
    },
    onPeriodChange(val) {
      this.selectedPeriod = val;
    },
    onConfirmClick() {
      let that = this;

      let period = that.lockPeriod;
      if (period <= 0) {
        that.isLoading = false;
        that.$Message.error({
          background: true,
          duration: 5,
          content: that.$t("asset.votePeriodException"),
        });
        return;
      }

      let amt = parseFloat(that.amount);
      if (isNaN(amt) || amt <= 0) {
        that.isLoading = false;
        that.$Message.error({
          background: true,
          duration: 5,
          content: that.$t("asset.voteAmountException"),
        });
        return;
      }
      if (
        new BigNumber(UTIL.toUnit(that.amount)).isGreaterThan(
          that.availableBalance
        )
      ) {
        that.isLoading = false;
        that.$Message.error({
          background: true,
          duration: 5,
          content: that.$t("asset.voteAmountException"),
        });
        return;
      }
      that.passwordType = 0;
      that.isPasswordModalShow = true;
    },
    async onPasswordConfirm(pwd) {
      let that = this;
      try {
        that.isPasswordModalShow = false;

        let userInfo = that.$store.state.userInfo;
        let mnemonic = UTIL.decryptKey(userInfo.key, pwd);
        if (!mnemonic) {
          that.isLoading = false;
          that.$Message.error({
            background: true,
            duration: 5,
            content: that.$t("global.passwordError"),
          });
          return;
        }

        that.isLoading = true;
        if (that.passwordType == 0) {
          await that.doLock(userInfo, mnemonic);
        } else if (that.passwordType == 1) {
          await that.doWithdraw(userInfo, mnemonic);
        }
        that.isLoading = false;
        return;
      } catch (err) {
        that.isLoading = false;
        let msg =
          ERROR.getCustomMessage(err, that.$t.bind(that)) ||
          that.$t("global.networkError");
        that.$Message.error({
          background: true,
          duration: 5,
          content: msg,
        });
      }
    },
    async doLock(userInfo, mnemonic) {
      let that = this;
      let period = parseInt(that.lockPeriod);
      console.log("period:" + period);
      if (isNaN(period) || period <= 0) {
        that.isLoading = false;
        that.$Message.error({
          background: true,
          duration: 5,
          content: that.$t("asset.votePeriodException"),
        });
        return;
      }

      let amt = parseFloat(that.amount);
      if (isNaN(amt) || amt <= 0) {
        that.isLoading = false;
        that.$Message.error({
          background: true,
          duration: 5,
          content: that.$t("asset.voteAmountException"),
        });
        return;
      }
      that.isLoading = true;
      if (that.net == "bts") {
        // BTS网络下，查询该ID对应信息
        let walletInfo = wallet.getAccountInfo(mnemonic, that.net);
        let vestResult = await tx.createCliffVestingBalance(
          walletInfo.privateKey,
          userInfo.name,
          amt,
          period
        );
        let txId = vestResult && vestResult.length ? vestResult[0].id : "";
        that.$Message.success({
          background: true,
          duration: 3,
          content: that.$t("asset.lockSuccess") + " " + txId,
        });
        await that.load();
        // that.$store.commit("setSelectedNode", that.userSelectedNode);
      }
      if (that.net == "sub") {
        // SUB网络，直接存储
      }
      that.clearLockInput();
      that.refreshBalance();
      this.isLoading = false;
      return;
    },
    async doWithdraw(userInfo, mnemonic) {
      let that = this;
      console.log(JSON.stringify(that.withdrawItem));
      let amt = UTIL.toToken(that.withdrawItem.withdraw_available);
      that.isLoading = true;
      if (that.net == "bts") {
        // BTS网络下，查询该ID对应信息
        let walletInfo = wallet.getAccountInfo(mnemonic, that.net);
        let withdrawResult = await tx.withdrawCliffVestingBalance(
          walletInfo.privateKey,
          userInfo.name,
          amt,
          that.withdrawItem.id
        );
        let txId =
          withdrawResult && withdrawResult.length ? withdrawResult[0].id : "";
        that.$Message.success({
          background: true,
          duration: 3,
          content: that.$t("asset.withdrawSuccess") + " " + txId,
        });
        await that.load();
      }
      if (that.net == "sub") {
        // SUB网络，直接存储
      }
      that.clearLockInput();
      that.refreshBalance();
      this.isLoading = false;
      return;
    },
    clearLockInput() {
      this.amount = "";
      this.selectedPeriod = 0;
    },
    refreshBalance() {
      let that = this;
      setTimeout(() => {
        that.$store.commit("setUserManualRefresh", new Date().getTime());
      }, 1000);
    },
  },
  computed: {
    net() {
      return this.$store.state.net;
    },
    address() {
      return (
        this.$store.state.userInfo.name || this.$store.state.userInfo.address
      );
    },
    selectedNode() {
      return this.$store.state.userInfo.selectedNode;
    },
    availableBalance() {
      let balances = this.$store.state.userInfo.balances || [];
      let coreAsset = balances.find(
        (it) => it.asset_type == DATA.TOKEN_ASSET_ID
      );
      if (coreAsset) {
        return coreAsset.balance;
      } else {
        return 0;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./AssetLock.less");
</style>